import { createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Transition as _Transition, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex items-center justify-between px-6 py-4 bg-white border-b-4 border-color-3" }
const _hoisted_2 = { class: "flex items-center" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("svg", {
  class: "w-6 h-6",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M4 6H20M4 12H20M4 18H11",
    stroke: "currentColor",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { class: "flex items-center" }
const _hoisted_6 = { class: "relative" }
const _hoisted_7 = { class: "absolute right-0 z-20 w-48 py-2 mt-2 bg-white rounded-md shadow-xl" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("a", {
  href: "#",
  class: "block px-4 py-2 text-sm text-gray-700 hover:bg-color-2 hover:text-white"
}, "Profile", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("a", {
  href: "#",
  class: "block px-4 py-2 text-sm text-gray-700 hover:bg-color-2 hover:text-white"
}, "Products", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleSidebarOpen && _ctx.toggleSidebarOpen(...args))),
        class: "text-gray-500 focus:outline-none lg:hidden"
      }, _hoisted_4)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _withDirectives(_createElementVNode("div", {
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggleSidebarOpen && _ctx.toggleSidebarOpen(...args))),
          class: "fixed inset-0 z-10 w-full h-full"
        }, null, 512), [
          [_vShow, _ctx.is_sidebar_open]
        ]),
        _createVNode(_Transition, {
          "enter-active-class": "transition duration-150 ease-out transform",
          "enter-from-class": "scale-95 opacity-0",
          "enter-to-class": "scale-100 opacity-100",
          "leave-active-class": "transition duration-150 ease-in transform",
          "leave-from-class": "scale-100 opacity-100",
          "leave-to-class": "scale-95 opacity-0"
        }, {
          default: _withCtx(() => [
            _withDirectives(_createElementVNode("div", _hoisted_7, [
              _hoisted_8,
              _hoisted_9,
              _createVNode(_component_router_link, {
                to: "/",
                class: "block px-4 py-2 text-sm text-gray-700 hover:bg-color-2 hover:text-white"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Log out")
                ]),
                _: 1
              })
            ], 512), [
              [_vShow, _ctx.is_sidebar_open]
            ])
          ]),
          _: 1
        })
      ])
    ])
  ]))
}